var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"icon":"fad fa-users-cog","title":"Uživatelé"},scopedSlots:_vm._u([{key:"buttons",fn:function(){return [_c('PrimaryLinkButton',{attrs:{"to":"/setup/users/create","icon":"fad fa-plus-circle","text":"Přidat uživatele"}})]},proxy:true}])}),_c('UsersList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }